import { render } from "./Finance.vue?vue&type=template&id=fba158e2&scoped=true"
import script from "./Finance.vue?vue&type=script&lang=js"
export * from "./Finance.vue?vue&type=script&lang=js"

import "./Finance.vue?vue&type=style&index=0&id=fba158e2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba158e2"]])

export default __exports__